import countries from '../constants/countries.json';
import languages from '../constants/languages.json';
import { ICountry, ILanguage } from '../interfaces';

const DOMAINS = countries.reduce((acc: any, country: any) => [...acc, ...country.topLevelDomain], []);

const COUNTRIES: ICountry[] = countries.map((country: any) => ({
    name: country.name,
    nativeName: country.nativeName,
    code: country.alpha3Code,
    countryCode: country.callingCodes,
    domain: country.topLevelDomain,
    flag: country.flag,
}));

const LANGUAGES: ILanguage[] = languages.map((language: any) => ({
    ...language,
}));

const getCountry = (code: string) => COUNTRIES.find((country) => country.code === code);

export {
    DOMAINS,
    COUNTRIES,
    LANGUAGES,
    getCountry,
};
